import React, { Component } from 'react';
import { Grid, } from '@material-ui/core';
import { WM_CTP_LOGO, WM_LW_LOGO_MOBILE } from '../../constants';
import { withStyles } from '@material-ui/styles';
import useStyles from './mobileStyles';
import { graphql, QueryRenderer } from 'react-relay';
import environment from '../../environment';
import WMMobileTop from './WMMobileTop';

const wmMobileSectionQuery = graphql`
    query WMMobileSectionQuery(
        $event_token: String!
        $guest_token: String!
        $quarter_id: Int!
    ){
        ...WMMobileTop_getLonewolfPersonalData @arguments(event_token: $event_token, guest_token: $guest_token, quarter_id: $quarter_id)
    }
`;

class WMMobileSection extends Component {
    constructor(props){
        super(props);
        this.state = {
            refetch: false,
        }

        this.refetchData = this.refetchData.bind(this);
    }

    refetchData(){
        this.setState(prevState => {
            return { refetch: !prevState.refetch };
        });
    }

    render(){
        const { classes, current_chapter, chapters, quarter_index, quarter_id, event_token, guest_token, page_number, changePage, event_id, landscape } = this.props;
        const variables = { event_token: event_token, guest_token: guest_token ? guest_token : ' ', quarter_id: quarter_id, refetch: this.state.refetch };

        return (
            <Grid item xs={12}>
                <Grid container direction='row' justifyContent='center' alignItems='center' className={landscape ? classes.wmMobileTopLS : classes.wmMobileTop}>
                    <img src={WM_CTP_LOGO} style={{height: '65px'}} />
                    <img src={WM_LW_LOGO_MOBILE} style={{height: '50px', marginLeft: '10px'}} />
                </Grid>
                <Grid container direction='row' justifyContent='center' alignItems='center' style={{marginTop: '6em'}}>
                {
                    quarter_index - 1 >= 0 ?
                    <span className={classes.pageArrow} onClick={() => this.props.changeChapter(-1)}>←</span> :
                    <span className={classes.pageArrowDisabled}>←</span>
                }
                <span className={classes.chapterName}>{current_chapter ? current_chapter.quarter_name : ''}</span>
                {
                    quarter_index + 1 < chapters.length ?
                    <span className={classes.pageArrow} onClick={() => this.props.changeChapter(1)}>→</span> :
                    <span className={classes.pageArrowDisabled}>→</span>
                }
                </Grid>
                <Grid container justifyContent='center'>
                    <QueryRenderer
                        environment={environment}
                        query={wmMobileSectionQuery}
                        variables={variables}
                        render={({ error, props }) => {
                            if(props){
                                return (
                                    <WMMobileTop
                                        quarter_id={quarter_id}
                                        getLonewolfPersonalData={props}
                                        chapters={chapters}
                                        guest_token={guest_token}
                                        event_token={event_token}
                                        page_number={page_number}
                                        changePage={changePage}
                                        event_id={event_id}
                                        refetchData={this.refetchData}
                                        landscape={landscape}
                                    />
                                )
                            }
                        }}
                    />
                </Grid>
            </Grid>
        )
    }
}

export default withStyles(useStyles)(WMMobileSection);